import React, { useEffect } from 'react';
import { useDataContext } from '@client/DataContext';
import { useNavigate } from 'react-router-dom';

interface ProfileProps {
    name: string;
    age: number;
    isSSR?: boolean;
}

export function Profile({ name, age }: ProfileProps) {
    const { data, loading, error } = useDataContext();
    const navigate = useNavigate();

    useEffect(() => {
        if (!loading && data !== null && !data) {
            const path = encodeURIComponent(`${window.location.pathname}${window.location.search}`);
            navigate(`/signin?path=${path}`);
        }
    }, [loading, data, navigate]);

    if (loading) return <p>Cargando...</p>;
    if (error) return <p>Error: {error}</p>;

    return (
        <>
            <h1>Perfil SSR</h1>
            <p>Nombre: {name}</p>
            <p>Edad: {age}</p>
            <p>Username: {data?.username}</p>
        </>
    );
}
